/**
 * Alert sounds made in the browser (no audio files). Browsers only allow sound after the
 * person has clicked or typed once on the page, so call unlockSound() from any click handler.
 */
let ctx: AudioContext | null = null;
const ac = () => {
  if (!ctx) { try { ctx = new AudioContext(); } catch { return null; } }
  if (ctx.state === 'suspended') void ctx.resume().catch(() => undefined);
  return ctx;
};
export function unlockSound() { ac(); }
if (typeof window !== 'undefined') {
  const once = () => { unlockSound(); window.removeEventListener('pointerdown', once); window.removeEventListener('keydown', once); };
  window.addEventListener('pointerdown', once); window.addEventListener('keydown', once);
}

function tone(at: number, freq: number, dur: number, vol: number, type: OscillatorType = 'square') {
  const c = ac(); if (!c) return;
  const o = c.createOscillator(); const g = c.createGain();
  o.type = type; o.frequency.setValueAtTime(freq, c.currentTime + at);
  g.gain.setValueAtTime(0, c.currentTime + at);
  g.gain.linearRampToValueAtTime(vol, c.currentTime + at + 0.01);
  g.gain.setValueAtTime(vol, c.currentTime + at + dur - 0.02);
  g.gain.linearRampToValueAtTime(0, c.currentTime + at + dur);
  o.connect(g).connect(c.destination); o.start(c.currentTime + at); o.stop(c.currentTime + at + dur + 0.02);
}

/** One loud old-phone "kriiing kriiing": a fast warble of two tones, twice. About 1.6 s. */
export function playRing() {
  for (const start of [0, 0.85]) {
    for (let i = 0; i < 14; i++) tone(start + i * 0.045, i % 2 ? 1250 : 980, 0.045, 0.32, 'square');
  }
}

/** A short, clear two-note chime for a new message. */
export function playMessage() {
  tone(0, 880, 0.14, 0.35, 'triangle');
  tone(0.16, 1320, 0.22, 0.35, 'triangle');
}

/** Rings every few seconds until stop() is called. */
export function startRinging(everyMs = 3000) {
  playRing();
  const t = window.setInterval(playRing, everyMs);
  return () => window.clearInterval(t);
}
